import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Chip, Divider, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import { useNavigate } from 'react-router-dom';
import { getCookie, removeCookie } from 'services/utils/CookieHandler';
import { HostName, urlSplashPage } from 'services/utils/globalVariables';


export default function DrawerMenu({ installer, setInstaller, data, loading, openMenu, setOpenMenu }) {

    const navigate = useNavigate()

    const menuItems = [
        {
            Label: "درباره ما ",
            Link: `${HostName}/about-us`,
        },
        {
            Label: "ارتباط با ما",
            Link: `${HostName}/contact-us`,
        },
        {
            Label: "نصب",
            Link: "#",
        },
    ]

    const handleLogout = () => {
        removeCookie("loginData")
        if(!getCookie("loginData2")) {
            // window.location.reload()
            navigate(urlSplashPage)
        }
    }

    const handleOpenInstaller = () => {
        setInstaller(true)
        localStorage.setItem("PressedNo", 1)
    }

    return (
        <Drawer
            anchor="left"
            open={openMenu}
            onClose={() => setOpenMenu(false)}
            PaperProps={{
                sx: {
                    width: 275,
                    direction: "ltr !important"
                }
            }}
        >
            <Stack sx={{height: "100%"}} justifyContent="space-between" >
                <Stack>
                    <Stack sx={{px: 2, pt: 3}} spacing={2}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Typography fontSize="18px" color="secondary" fontWeight="bold">{loading ? data.DisplayName : "---"}</Typography>
                        </Stack>
                        <Stack sx={{mt: 3}} direction="row" justifyContent="space-between">
                            <Chip
                                icon={<DiamondOutlinedIcon sx={{width: "16px", fontSize: "16px"}} color="primary" />}
                                label={<Typography variant="body2" sx={{color: "#fff", direction: "ltr"}}><b>{loading ? data.Point : "-"}</b> <span style={{marginRight: "0.25rem"}}>امتیاز</span></Typography>}
                                variant="filled"
                                color="secondary"
                                sx={{direction: "rtl", "& .MuiSvgIcon-root": {mr: "5px !important", ml: "-6px !important"}, px: 0.5}}
                            />
                            <Stack spacing="6px" direction="row" alignItems="center" onClick={handleLogout}>
                                <LogoutOutlinedIcon sx={{width: "28px", fontSize: "28px", transform: "rotate(180deg)"}} color="primary" />
                                <Typography lineHeight="1.2rem" fontWeight="bold">خروج</Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                    <Divider sx={{my: 2, borderWidth: "2px", borderColor: "var(--mc1)"}} />
                    <Stack sx={{px: 2}}>
                        <List>
                            {menuItems.map((val, i) => {
                                return (
                                    <ListItem key={i}>
                                        {
                                            val.Link != "#" ?
                                                <a href={val.Link} target='_blank'><ListItemText sx={{"& span": {fontWeight: "bold"}}} primary={val.Label}/></a>
                                            :(!(window.matchMedia('(display-mode: standalone)').matches) && <ListItemText onClick={handleOpenInstaller} sx={{"& span": {fontWeight: "bold"}}} primary={val.Label}/>)
                                        }
                                    </ListItem>
                                )
                            })}
                        </List>
                    </Stack>
                </Stack>
                <Typography textAlign="center" sx={{p: 1, fontSize: "14px"}} variant="body1" color="initial">
                    <a href="#">designed by webcade</a>
                </Typography>
            </Stack>
        </Drawer>
    )
}